export const ActionTypes = {
    SET_SKU_DATA: "details/set_data",
    FETCH_SKU_DATA_PROGRESS: "detail/fetch_sku_data_progress",
    FETCH_SKU_DATA_SUCCESS: "detail/fetch_sku_data_success",
    FETCH_SKU_DATA_NOT_FOUND: "detail/fetch_sku_data_not_found",
    FETCH_SKU_DATA_FAILED: "detail/fetch_sku_data_failed",
    FETCH_A_PLUS_DATA_PROGRESS: "detail/fetch_a_plus_content_in_progress",
    FETCH_A_PLUS_DATA_SUCCESS: "detail/fetch_a_plus_content_in_success",
    FETCH_A_PLUS_DATA_FAILED: "detail/fetch_a_plus_content_in_failed",
    FETCH_EXPLORE_DATA_PROGRESS: "detail/fetch_explore_data_progress",
    FETCH_EXPLORE_DATA_SUCCESS: "detail/fetch_explore_data_success",
    FETCH_EXPLORE_DATA_FAILED: "detail/fetch_explore_data_failed",
};
